import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import {
  provideAppInitializer,
  inject,
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  importProvidersFrom,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideOptimus } from '@openng/optimus-ui/config';
import Material from '@openng/optimus-ui-themes/material';
import { AuthService } from './auth.service';
import { authInterceptor } from './interceptor';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => {
      const authService = inject(AuthService);
      return authService.tryRestoreSession();
    }),
    provideOptimus({
      theme: {
        preset: Material,
        options: {
          darkModeSelector: false || 'none',
        },
      },
    }),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    importProvidersFrom(),
    provideHttpClient(withXhr(), withInterceptors([authInterceptor])),
  ],
};
